// extracted by mini-css-extract-plugin
export default {"link":"styles_link__hr23g","link__active":"styles_link__active__0z-Y8","counterValue":"styles_counterValue__A3twS"};